import * as React from 'react';
import { useEffect, useState } from 'react';
// @ts-ignore
import styles from './CaseChatCreateMessageFilePreview.module.scss';
import heic2any from 'heic2any';
import useLoading from '../../Modules/Base/Hooks/useLoading';

interface CaseChatCreateMessageFilePreviewProps {
	removeFile: (file: File) => void;
	selectedFile: File;
}

export default function CaseChatCreateMessageFilePreview(
	props: CaseChatCreateMessageFilePreviewProps,
) {
	const [filePreview, setFilePreview] = useState<string | null>(null);
	const { isLoading, setIsLoading, RenderLoading } = useLoading();
	const [filePreviewSize, setFilePreviewSize] = useState('cover');
	const { removeFile, selectedFile } = props;

	useEffect(() => {
		if (selectedFile && selectedFile?.type?.search('image/') !== -1) {
			if (
				selectedFile.type === 'image/heic' ||
				selectedFile.type === 'image/heif'
			) {
				setIsLoading(true);
				setFilePreview(null);
				heic2any({
					blob: selectedFile,
				})
					.then(conversionResult => {
						// @ts-ignore
						setFilePreview(URL.createObjectURL(conversionResult));
						setFilePreviewSize('cover');
						setIsLoading(false);
					})
					.catch(e => {
						setFilePreview('/dist/file.png');
						setFilePreviewSize('auto');
						setIsLoading(false);
					});
			} else {
				setFilePreview(URL.createObjectURL(selectedFile));
				setFilePreviewSize('cover');
			}
		} else {
			setFilePreview('/dist/file.png');
			setFilePreviewSize('auto');
		}
	}, [selectedFile]);

	if (isLoading) {
		return <RenderLoading />;
	}

	return (
		<div
			className={styles.wrapper}
			style={{
				backgroundSize: filePreviewSize,
				backgroundImage: filePreview ? 'url(' + filePreview + ')' : undefined,
			}}>
			<img
				className={styles.removeButton}
				src={'/dist/icons/close.svg'}
				onClick={() => removeFile(selectedFile)}
			/>
		</div>
	);
}
